import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useSidebar } from '../../../context/SidebarContext';
import { useBreadcrumb } from '../../../context/BreadcrumbContext';
import { Box, Grid, Typography } from '@mui/material';
import VerificationIcon from '../../../assets/main/verification-icon.svg'
import UserProfileTab from '../../../components/UserProfileTab'

import {
  CustomAccordion,
  PageCard,
  ExpandIcon,
  CustomLink,
  VerificationContainer,
  VerificationImageContainer,

  ButtonGroupContainer,
  FieldLabel,
  FullWidthField,
  InterviewFormContainer,
  StyledInput,
  DateTextField,
  ClearScheduleButton,
  ScheduleButtonGroup,
  ScheduleInfoContainer,
  ScheduleText,
  UpdateScheduleButton,
  AcceptButton,
  RejectButton
} from './styles';


// redux
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../../store';
import {
  fetchWorkerDetail,
  selectWorkerDetails,
  IWorkerUser,
  updateWorkerStatus,
  updateWorkerRates,
  fetchWorkerRoleDocumentRequirementsBulk
} from '../../../modules/worker';
import { DatePicker, LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {
  scheduleInterview,
  selectScheduledInterviewMessage,
  selectScheduledInterviewMessageError,
  selectScheduledInterviewMessageLoading,
  clearScheduledInterviewMessage,
  getInterviewDetail,
  selectInterviewDetail,
  updateInterview,
  selectUpdateInterviewMessage,
  selectUpdateInterviewError,
  selectUpdateInterviewLoading,
  clearUpdateInterviewMessage,
  cancelInterview,
  selectCancelInterviewMessage,
  selectCancelInterviewError,
  selectCancelInterviewLoading,
  clearCancelInterviewMessage,
} from '../../../modules/interview';
import ConfirmationDialog from '../../../components/common/ConfirmationDialog';
import AlertPopup from '../../../components/common/AlertPopup';
import SetWorkerPay from './components/SetWorkerPay'


// const toSentenceCase = (str: string) => {
//   if (!str) return '';
//   const result = str.split('_').join(' ');
//   return result.charAt(0).toUpperCase() + result.slice(1).toLowerCase();
// };

const WorkerReviewPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { setActivePage } = useSidebar();
  const { setPath, setIsShow } = useBreadcrumb();

  const dispatch: AppDispatch = useDispatch()
  const navigate: ReturnType<typeof useNavigate> = useNavigate();
  const workerDetails = useSelector(selectWorkerDetails);
  const scheduledInterviewMessage = useSelector(selectScheduledInterviewMessage);
  const scheduledInterviewMessageError = useSelector(selectScheduledInterviewMessageError);
  const interviewDetail = useSelector(selectInterviewDetail);
  const updateInterviewMessage = useSelector(selectUpdateInterviewMessage);
  const updateInterviewError = useSelector(selectUpdateInterviewError);
  const cancelInterviewMessage = useSelector(selectCancelInterviewMessage);
  const cancelInterviewError = useSelector(selectCancelInterviewError);

  const [workerId, setWokerId] = useState<number>(0)
  const [user, setUser] = useState<IWorkerUser>({
    email: "",
    first_name: "",
    last_name: "",
    phone_number: "",
    profile_picture: ""
  })
  const [interviewDate, setInterviewDate] = useState<dayjs.Dayjs | null>(null);
  const [interviewTime, setInterviewTime] = useState<dayjs.Dayjs | null>(null);
  const [meetingLink, setMeetingLink] = useState<string>("");
  const [isEdit, setIsEdit] = useState<boolean>(false)
  // const [isConfirmClearOpen, setIsConfirmClearOpen] = useState(false);
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertSeverity, setAlertSeverity] = useState<'success' | 'error'>('success');
  const [confirmation, setConfirmation] = useState<{ open: boolean; title: string; message: string; onConfirm: (() => void) | null }>({ open: false, title: '', message: '', onConfirm: null });
  const [isSetWorkerPayOpen, setIsSetWorkerPayOpen] = useState(false);
  const [interviewViewed, setInterviewViewed] = useState<boolean>(false)
  const [requiredDocuments, setRequiredDocuments] = useState<any[]>([]);

  useEffect(() => {
    try {
      if (id) {
        const workerId = parseInt(id)
        setWokerId(workerId);
        dispatch(fetchWorkerDetail(workerId) as any);
        // dispatch(getInterviewDetail(workerId) as any);
      }
    } catch (err) {
      console.log(err);
    }
  }, [dispatch, id])

  useEffect(() => {
    if (workerDetails) {
      setUser(workerDetails.user)
    }

    if (workerDetails?.worker_onboarding_id) {
      dispatch(getInterviewDetail(workerDetails?.worker_onboarding_id) as any);
    }

  }, [workerDetails, dispatch])

  const handleScheduleInterview = () => {
    if (!interviewDate) {
      setAlertMessage("Interview Date is required.");
      setAlertSeverity('error');
      setIsAlertOpen(true);
      return;
    }
    if (!interviewTime) {
      setAlertMessage("Interview Time is required.");
      setAlertSeverity('error');
      setIsAlertOpen(true);
      return;
    }
    if (!meetingLink) {
      setAlertMessage("Meeting Link is required.");
      setAlertSeverity('error');
      setIsAlertOpen(true);
      return;
    }

    if (!workerDetails?.worker_onboarding_id || !workerDetails.worker.org?.org_id) {
      console.error("Cannot schedule/update interview: missing worker onboarding ID or organization ID.");
      setAlertMessage("Internal Error: Missing worker details.");
      setAlertSeverity('error');
      setIsAlertOpen(true);
      return;
    }

    const commonInterviewData = {
      date: interviewDate.format('YYYY-MM-DD'),
      time: interviewTime.format('HH:mm:ss'),
      meeting_link: meetingLink,
    };

    if (isEdit && interviewDetail && interviewDetail.length > 0 && interviewDetail[0].interview_id) {
      // Update existing interview
      dispatch(updateInterview({
        interviewId: interviewDetail[0].interview_id,
        ...commonInterviewData,
      }) as any);
    } else {
      // Schedule new interview
      const scheduleData = {
        title: `Worker Interview - ${user.first_name} ${user.last_name}`,
        worker: workerId,
        org: workerDetails.worker.org.org_id,
        message: "Your interview has been scheduled.",
        worker_onboarding: workerDetails.worker_onboarding_id,
        ...commonInterviewData,
      };
      dispatch(scheduleInterview(scheduleData as any));
    }
  };

  const handleClearScheduleConfirm = () => {
    // setIsConfirmClearOpen(false); // Close the confirmation dialog
    if (interviewDetail && interviewDetail.length > 0 && interviewDetail[0].interview_id) {
      dispatch(cancelInterview({ interviewId: interviewDetail[0].interview_id }) as any);
    } else {
      console.error("Cannot clear schedule: no interview ID found.");
    }
  };

  useEffect(() => {
    if (interviewDetail && interviewDetail.length > 0) {
      const details = interviewDetail[0];
      if (details.date && details.time) {
        const interviewDateTime = dayjs(`${details.date} ${details.time}`);
        setInterviewDate(interviewDateTime);
        setInterviewTime(interviewDateTime);
        setIsEdit(true);
      } else {
        setInterviewDate(details.date ? dayjs(details.date) : null);
        setInterviewTime(details.time ? dayjs(details.time, 'HH:mm:ss') : null);
      }
      setMeetingLink(details.meeting_link || "");
      setInterviewViewed(details.is_viewed)
    }
  }, [interviewDetail]);

  useEffect(() => {
    if (workerDetails?.preferred_roles && workerDetails.preferred_roles.length > 0) {
      const roleIds = workerDetails.preferred_roles.map((r: any) => r.role_id);
      dispatch(fetchWorkerRoleDocumentRequirementsBulk(roleIds) as any)
        .then((result: any) => {
          if (fetchWorkerRoleDocumentRequirementsBulk.fulfilled.match(result)) {
            const requirements = result.payload;
            const uploadedDocs = workerDetails.worker_onboarding_documents || [];
            const mergedDocs = requirements.map((req: any) => {
              const matchingUpload = uploadedDocs.find((u: any) => u.document_type === req.requirement_id);
              return {
                ...req,
                uploaded_document: matchingUpload ? {
                  ...matchingUpload,
                  issuedDate: matchingUpload.document_issued_on ? dayjs(matchingUpload.document_issued_on) : null,
                  expiresDate: matchingUpload.document_expiring_on ? dayjs(matchingUpload.document_expiring_on) : null,
                } : null
              };
            });
            setRequiredDocuments(mergedDocs);
          }
        });
    }
  }, [workerDetails, dispatch]);

  const handleAlertClose = () => {
    setIsAlertOpen(false);
    if (scheduledInterviewMessage || scheduledInterviewMessageError) {
      dispatch(clearScheduledInterviewMessage());
    }
    if (updateInterviewMessage || updateInterviewError) {
      dispatch(clearUpdateInterviewMessage());
    }
    if (cancelInterviewMessage || cancelInterviewError) {
      dispatch(clearCancelInterviewMessage());
    }
  };

  const scheduledLoading = useSelector(selectScheduledInterviewMessageLoading);
  const updateLoading = useSelector(selectUpdateInterviewLoading);
  const cancelLoading = useSelector(selectCancelInterviewLoading);

  useEffect(() => {
    if (scheduledInterviewMessage) {
      setAlertMessage(scheduledInterviewMessage);
      setAlertSeverity('success');
      setIsAlertOpen(true);
      if (workerDetails?.worker_onboarding_id) {
        dispatch(getInterviewDetail(workerDetails.worker_onboarding_id) as any);
      }
    }
    if (scheduledInterviewMessageError) {
      setAlertMessage(scheduledInterviewMessageError);
      setAlertSeverity('error');
      setIsAlertOpen(true);
    }
  }, [scheduledInterviewMessage, scheduledInterviewMessageError, workerDetails?.worker_onboarding_id, dispatch]);

  useEffect(() => {
    if (updateInterviewMessage) {
      setAlertMessage(updateInterviewMessage);
      setAlertSeverity('success');
      setIsAlertOpen(true);
    }
    if (updateInterviewError) {
      setAlertMessage(updateInterviewError);
      setAlertSeverity('error');
      setIsAlertOpen(true);
    }
  }, [updateInterviewMessage, updateInterviewError]);

  useEffect(() => {
    if (cancelInterviewMessage) {
      setAlertMessage(cancelInterviewMessage);
      setAlertSeverity('success');
      setIsAlertOpen(true);
      // Optionally, refetch interview details to update the UI
      if (workerDetails?.worker_onboarding_id) {
        dispatch(getInterviewDetail(workerDetails.worker_onboarding_id) as any);
      }
    }
    if (cancelInterviewError) {
      setAlertMessage(cancelInterviewError);
      setAlertSeverity('error');
      setIsAlertOpen(true);
    }
  }, [cancelInterviewMessage, cancelInterviewError, dispatch, workerDetails?.worker_onboarding_id]);


  const getUserName = React.useCallback(() => {
    if (user.first_name && user.last_name) {
      return user.first_name + " " + user.last_name
    } else {
      return user.email
    }
  }, [user]);

  useEffect(() => {
    setActivePage('worker');
    setPath([
      { title: 'Management', path: '/' },
      { title: 'Worker', path: '/workers' },
      { title: getUserName(), path: '' },
    ]);
    setIsShow(true);
  }, [setActivePage, setPath, user, getUserName, setIsShow]);

  const handleApproveWorker = () => {
    const missingDates = requiredDocuments.filter(req => {
      const doc = req.uploaded_document;
      return doc && (
        (req.document_type?.req_issue_date && !doc.issuedDate) ||
        (req.document_type?.req_expiry_date && !doc.expiresDate)
      );
    });

    if (missingDates.length > 0) {
      const names = missingDates.map(m => m.document_type?.document_type).join(', ');
      setAlertMessage(`Cannot approve worker. Mandatory dates are missing for: ${names}`);
      setAlertSeverity('error');
      setIsAlertOpen(true);
      return;
    }

    setConfirmation({
      open: true,
      title: 'Confirm Approval',
      message: 'Are you sure you want to approve this worker?',
      onConfirm: () => {
        if (workerId) {
          dispatch(updateWorkerStatus({ workerId: workerId, action: 'accept' }) as any)
            .then((result: any) => {
              if (updateWorkerStatus.fulfilled.match(result)) {
                setAlertMessage('Worker approved successfully!');
                setAlertSeverity('success');
                setIsAlertOpen(true);
                setIsSetWorkerPayOpen(true)
                dispatch(fetchWorkerDetail(workerId) as any); // Refresh data
              } else {
                setAlertMessage(result.payload?.message || 'Failed to approve worker.');
                setAlertSeverity('error');
                setIsAlertOpen(true);
              }
            });
        }
        setConfirmation({ open: false, title: '', message: '', onConfirm: null });
      }
    });
  };

  const handleRejectWorker = () => {
    setConfirmation({
      open: true,
      title: 'Confirm Rejection',
      message: 'Are you sure you want to reject this worker?',
      onConfirm: () => {
        if (workerId) {
          dispatch(updateWorkerStatus({ workerId: workerId, action: 'reject' }) as any)
            .then((result: any) => {
              if (updateWorkerStatus.fulfilled.match(result)) {
                setAlertMessage('Worker rejected successfully!');
                setAlertSeverity('success');
                setIsAlertOpen(true);
                dispatch(fetchWorkerDetail(workerId) as any); // Refresh data
              } else {
                setAlertMessage(result.payload?.message || 'Failed to reject worker.');
                setAlertSeverity('error');
                setIsAlertOpen(true);
              }
            });
        }
        setConfirmation({ open: false, title: '', message: '', onConfirm: null });
      }
    });
  };

  const handleSetWorkerPaySubmit = (data: { workerPay: string; facilityCharge: string }) => {
    setIsSetWorkerPayOpen(false);
    dispatch(updateWorkerRates({
      workerId: workerId,
      data: {
        worker_amount_per_hour: parseFloat(data.workerPay),
        facility_amount_per_hour: parseFloat(data.facilityCharge)
      }
    }) as any)
      .then((result: any) => {
        if (updateWorkerRates.fulfilled.match(result)) {
          setAlertMessage('Worker pay updated successfully!');
          setAlertSeverity('success');
          setIsAlertOpen(true);
          dispatch(fetchWorkerDetail(workerId) as any); // Refresh data
        } else {
          setAlertMessage(result.payload?.message || 'Failed to update worker pay.');
          setAlertSeverity('error');
          setIsAlertOpen(true);
        }
      });
  };


  return (
    <Box>
      {workerDetails &&
        <PageCard>
          <UserProfileTab
            user={user}
            id={workerId}
            status={workerDetails.worker.status}
          />
        </PageCard>
      }
      <PageCard>
        <CustomAccordion marginBottom={4}>
          <Grid container>
            <Grid size={6}>
              <Typography variant="subtitle1" fontWeight="bold" color={workerDetails?.is_viewed ? 'primary' : 'textPrimary'}>
                Personal Details
              </Typography>
              <Typography variant='subtitle2' fontWeight="body2" color={workerDetails?.is_viewed ? 'primary' : 'textPrimary'}>
                Review the worker's basic details and documents
              </Typography>
            </Grid>
            <Grid size={6} >
              <CustomLink
                flexShrink={0}
                textAlign="right"
                onClick={() => {
                  if (workerDetails?.is_viewed) {
                    navigate(`/worker/${id}/details/`)
                  } else {
                    navigate(`/worker/${id}/onboarding/`)
                  }
                }}
              >
                <Typography color={workerDetails?.is_viewed ? 'primary' : 'textPrimary'}>
                  Review the details <ExpandIcon />
                </Typography>
              </CustomLink>
            </Grid>
          </Grid>
        </CustomAccordion>

        {/* <CustomAccordion marginBottom={4}>
          <Grid container>
            <Grid size={6}>
              <Typography variant="subtitle1" fontWeight="bold">
                Bank Details
              </Typography>
              <Typography variant='subtitle2' fontWeight="body2">
                Review the worker's bank information
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            {workerDetails?.bank_details && Object.entries(workerDetails.bank_details).map(([key, value]) => (
              <Grid size={3} key={key} sx={{ mb: 2 }}>
                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600 }}>
                  {toSentenceCase(key)}
                </Typography>
                <Typography variant="body1">
                  {String(value)}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </CustomAccordion> */}

        <CustomAccordion marginBottom={4}>
          <Grid container>
            <Grid size={6}>
              <Typography variant="subtitle1" fontWeight="bold">
                Interview Schedule
              </Typography>
              <Typography variant='subtitle2' fontWeight="body2">
                Set the interview date, time, and meeting link below. This will be visible in the worker app.
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={2}>

            <InterviewFormContainer>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box sx={{ position: 'relative' }}>
                  <FieldLabel>Interview Date</FieldLabel>
                  <DatePicker format="DD/MM/YYYY"
                    disablePast
                    enableAccessibleFieldDOMStructure={false}
                    slots={{ textField: DateTextField }}
                    value={interviewDate}
                    onChange={(newValue) => setInterviewDate(newValue)}
                    slotProps={{
                      textField: {
                        variant: "outlined",
                        size: "small",
                        fullWidth: true,
                      },
                      popper: {
                        disablePortal: true,
                        sx: {
                          position: 'absolute',
                          top: '100%',
                          left: '0',
                          transform: 'none !important',
                          zIndex: 1300,
                        }
                      }
                    }}
                  />
                </Box>

                <Box sx={{ position: 'relative' }}>
                  <FieldLabel>Interview Time</FieldLabel>
                  <TimePicker
                    minTime={interviewDate && dayjs().isSame(interviewDate, 'day') ? dayjs() : undefined}
                    enableAccessibleFieldDOMStructure={false}
                    slots={{ textField: DateTextField }}
                    value={interviewTime}
                    onChange={(newValue) => setInterviewTime(newValue)}
                    slotProps={{
                      textField: {
                        variant: "outlined",
                        size: "small",
                        fullWidth: true,
                      },
                      popper: {
                        disablePortal: true,
                        sx: {
                          position: 'absolute',
                          top: '100%',
                          left: '0',
                          transform: 'none !important',
                          zIndex: 1300,
                        }
                      }
                    }}
                    ampm={false}
                  />
                </Box>

              </LocalizationProvider>
              <FullWidthField>
                <FieldLabel>Meeting Link</FieldLabel>
                <StyledInput
                  fullWidth
                  value={meetingLink}
                  onChange={(event) => setMeetingLink(event.target.value)}
                  size="small"
                  placeholder="https://meet.google.com/..."
                />
              </FullWidthField>
            </InterviewFormContainer>

            {isEdit &&
              <ScheduleInfoContainer>
                {interviewDate && interviewTime &&
                  <ScheduleText>
                    Interview scheduled on {' '}
                    <span style={{ fontWeight: 'bold', color: '#333' }}>
                      {interviewDate.format('DD/MM/YYYY')}
                    </span>
                    {' '}at{' '}
                    <span style={{ fontWeight: 'bold', color: '#333' }}>
                      {interviewTime.format('hh:mm A')}
                    </span>
                  </ScheduleText>
                }

                <ScheduleButtonGroup>
                  <ClearScheduleButton color='error' variant="outlined" onClick={() => handleClearScheduleConfirm()} disabled={cancelLoading}>
                    Cancel Interview
                  </ClearScheduleButton>

                  <UpdateScheduleButton variant="contained" onClick={handleScheduleInterview} disabled={updateLoading}>
                    Reschedule Interview
                  </UpdateScheduleButton>
                </ScheduleButtonGroup>
              </ScheduleInfoContainer>

            }
            {!isEdit &&
              <ScheduleInfoContainer>
                <ScheduleText>
                  Interview is not scheduled, please schedule now
                </ScheduleText>
                <ScheduleButtonGroup>
                  <UpdateScheduleButton variant="contained" onClick={handleScheduleInterview} disabled={scheduledLoading}>
                    Create Interview
                  </UpdateScheduleButton>
                </ScheduleButtonGroup>
              </ScheduleInfoContainer>
            }

          </Grid>
        </CustomAccordion>

        <CustomAccordion marginBottom={4}>
          <Grid container>
            <Grid size={6}>
              <Typography variant="subtitle1" fontWeight="bold" color={interviewViewed ? 'primary' : 'textPrimary'}>
                Interview Recordings
              </Typography>
              <Typography variant='subtitle2' fontWeight="body2" color={interviewViewed ? 'primary' : 'textPrimary'}>
                Review the worker's interview recordings
              </Typography>
            </Grid>
            <Grid size={6} >
              <CustomLink
                flexShrink={0}
                textAlign="right"
                onClick={() => { navigate(`/worker/${id}/interview/`) }}
              >
                <Typography color={interviewViewed ? 'primary' : 'textPrimary'}>
                  Review the details <ExpandIcon />
                </Typography>
              </CustomLink>
            </Grid>
          </Grid>
        </CustomAccordion>

        <CustomAccordion marginBottom={0}>
          <Grid container>
            <Grid size={6}>
              <Typography variant="subtitle1" fontWeight="bold">
                Set Worker Payee
              </Typography>
              <Typography variant='subtitle2' fontWeight="body2">
                Set the payee for the worker and facility
              </Typography>
            </Grid>
            <Grid size={6} >
              <CustomLink
                flexShrink={0}
                textAlign="right"
                onClick={() => setIsSetWorkerPayOpen(true)}
              >
                Review the details <ExpandIcon />
              </CustomLink>
            </Grid>
          </Grid>
        </CustomAccordion>
      </PageCard>
      <PageCard>
        <VerificationContainer container>
          <Grid size={6}>
            <Grid container spacing={2} alignItems="center">
              <VerificationImageContainer size={1}>
                <img src={VerificationIcon} alt="Verification Icon" />
              </VerificationImageContainer>
              <Grid size={11}>
                <Typography variant="subtitle1" fontWeight="bold">
                  Verification Action
                </Typography>
                <Typography variant='subtitle2' fontWeight="body2">
                  Confirm the worker's eligibility and finalize their status
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid size={6} >
            <Box flexShrink={0} textAlign="right">
              <ButtonGroupContainer>
                <RejectButton
                  variant="outlined"
                  onClick={handleRejectWorker}
                  disabled={(!workerDetails?.is_viewed || workerDetails.worker.onboarding_status === "rejected" || !interviewDetail?.[0]?.is_viewed)}
                >
                  Reject
                </RejectButton>
                <AcceptButton
                  variant="contained"
                  onClick={handleApproveWorker}
                  disabled={(!workerDetails?.is_viewed || workerDetails.worker.onboarding_status === "approved")}
                >
                  Approve
                </AcceptButton>
              </ButtonGroupContainer>
            </Box>
          </Grid>
        </VerificationContainer>
      </PageCard>
      <ConfirmationDialog
        open={confirmation.open}
        onClose={() => setConfirmation({ open: false, title: '', message: '', onConfirm: null })}
        onConfirm={confirmation.onConfirm || (() => { })}
        title={confirmation.title}
        message={confirmation.message}
      />

      <SetWorkerPay
        open={isSetWorkerPayOpen}
        onClose={() => setIsSetWorkerPayOpen(false)}
        onSubmit={handleSetWorkerPaySubmit}
        initialWorkerPay={`${workerDetails?.worker?.worker_amount_per_hour}`}
        initialFacilityCharge={`${workerDetails?.worker?.facility_amount_per_hour}`}
      />

      <AlertPopup
        open={isAlertOpen}
        onClose={handleAlertClose}
        message={alertMessage}
        severity={alertSeverity}
      />
    </Box>
  );
};

export default WorkerReviewPage;


